import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useAppDispatch } from "../../store/hooks";
import { setLocation } from "../../store/slices/locationSlice";
import HeaderView from "./HeaderView";
import FooterView from "./FooterView";
import APPConfig from "../../config";

const { Content } = Layout;

const stripePromise = loadStripe(APPConfig.STRIPE_PK);

const LayoutView = () => {
  const dispatch = useAppDispatch();

  const changeLocation = (location_result: any) => {
    dispatch(setLocation(location_result));
  };

  return (
    <Layout>
      <HeaderView onChangeLocation={changeLocation} />
      <Layout>
        <Content
          style={{
            paddingTop: 12,
            minHeight: "80vh",
            backgroundColor: "white",
            overflow: "visible",
          }}
        >
          <Elements stripe={stripePromise}>
            <Outlet />
          </Elements>
        </Content>
      </Layout>
      <FooterView />
    </Layout>
  );
};

export default LayoutView;